import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Card, Row, Col, Button, Input, Result, Badge } from "antd";
import { useSelector, useDispatch } from "react-redux";
import ticketsActions from "../../../redux/ticket/actions";
import { epochToNormalDate, convertToEuro } from "../../../utils/utility";
import "./index.css";
import DateSearchForm from "../../UI/DateSearchForm";

const SendEmailPage = () => {
  const dispatch = useDispatch();
  const { getReservationInfoByPeriod, sendEmailTickets } = ticketsActions;
  const { adminToken, companies } = useSelector((state) => state.mainReducer);
  const { reservationInfoByPeriod } = useSelector(
    (state) => state.ticketReducer
  );

  const [startDate, setStartDate] = useState(dayjs().startOf("day"));
  const [startTime, setStartTime] = useState(dayjs().startOf("day"));
  const [endDate, setEndDate] = useState(dayjs().endOf("day"));
  const [endTime, setEndTime] = useState(dayjs().endOf("day"));

  const [searchTerm, setSearchTerm] = useState("");
  const [userNewEmail, setUserNewEmail] = useState(null);

  const combinedStartDateTime = startDate
    .hour(startTime.hour())
    .minute(startTime.minute());

  const combinedEndDateTime = endDate
    .hour(endTime.hour())
    .minute(endTime.minute());

  useEffect(() => {
    if (adminToken && companies.length > 0) {
      dispatch(
        getReservationInfoByPeriod(
          adminToken,
          companies[0]?.id,
          combinedStartDateTime.unix().toString(),
          combinedEndDateTime.unix().toString()
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredReservations = reservationInfoByPeriod
    ?.filter((reservation) => reservation.ticketNumber !== null) // Първо филтрираме по ticketNumber
    ?.filter((reservation) => {
      const searchLower = searchTerm.toLowerCase();
      return (
        `${reservation.forPerson} ${reservation.email} ${reservation.phone}`
          .toLowerCase()
          .includes(searchLower) ||
        epochToNormalDate(reservation.courseDateTime).includes(searchTerm)
      );
    });

  const sendEmailTicketsAgain = (ticketNumber) => {
    dispatch(
      sendEmailTickets(adminToken, companies[0]?.id, ticketNumber, userNewEmail)
    );
  };

  const statusMap = {
    0: { text: "Валиден", badge: "success" },
    1: { text: "Обслужен", badge: "processing" },
    "-1": { text: "Изтекъл", badge: "default" },
    "-2": { text: "Отменен", badge: "error" },
  };

  const status = (record) =>
    statusMap[String(record.status)] || {
      text: "Неизвестен",
      badge: "warning",
    };

  return (
    <>
      <DateSearchForm
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        startTime={startTime}
        endTime={endTime}
        setStartTime={setStartTime}
        setEndTime={setEndTime}
        combinedStartDateTime={combinedStartDateTime}
        combinedEndDateTime={combinedEndDateTime}
        heading="Изпращане на повторен имейл"
      />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Input
          className="send-email-search-input"
          placeholder="Търси по име, имейл, дата или телефонен номер"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      {filteredReservations?.length === 0 ? (
        <Result icon={null} title={<div>Няма намерени резултати</div>} />
      ) : (
        <Row gutter={[16, 16]} justify="flex-start">
          {filteredReservations?.reverse()?.map((reservation, index) => (
            <Col key={index} xs={24} sm={24} md={12} lg={6}>
              <Card
                hoverable
                style={{
                  width: "100%",
                  marginBottom: "20px",
                  border: reservation?.isAnnulSale && "2px solid red",
                }}
              >
                <h3 style={{ marginBottom: "5px", textAlign: "center" }}>
                  {reservation.cityFrom} - {reservation.cityTo}
                </h3>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p>TickSys Номер </p>
                  <p className="send-email-card-text">
                    {reservation.ticketNumber}
                  </p>
                </div>

                <div className="send-email-card-text-container">
                  <p>Име </p>
                  <p className="send-email-card-text">
                    {reservation.forPerson}
                  </p>
                </div>
                <div className="send-email-card-text-container">
                  <p>Имейл </p>
                  <p className="send-email-card-text">{reservation.email}</p>
                </div>
                <div className="send-email-card-text-container">
                  <p>Статус </p>
                  <p className="send-email-card-text">
                    <Badge
                      status={status(reservation).badge}
                      text={status(reservation).text}
                    />
                  </p>
                </div>

                <div className="send-email-card-text-container">
                  <p>Телефонен номер </p>
                  <p className="send-email-card-text">{reservation.phone}</p>
                </div>
                <div className="send-email-card-text-container">
                  <p>Заминаване </p>
                  <p className="send-email-card-text">
                    {epochToNormalDate(reservation.courseDateTime)}
                  </p>
                </div>

                <div className="send-email-card-text-container">
                  <p>Цена </p>
                  <p className="send-email-card-text">€ {reservation.price}</p>
                </div>
                <div className="send-email-card-text-container">
                  <p>Цена BGN </p>
                  <p className="send-email-card-text">
                    {convertToEuro(reservation.price)}лв
                  </p>
                </div>
                <div className="send-email-card-text-container">
                  <p>Резервация дата </p>
                  <p className="send-email-card-text">
                    {epochToNormalDate(reservation.oprReservedDateTime)}
                  </p>
                </div>
                {reservation?.isAnnulSale ? (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <p
                        style={{
                          fontSize: "20px",
                          marginBottom: "5px",
                          fontWeight: "bold",
                          color: "red",
                        }}
                      >
                        Анулиран билет
                      </p>

                      <Input
                        style={{ height: "35px" }}
                        placeholder="Нов имейл"
                        disabled
                      />
                    </div>
                    <Button
                      style={{ width: "100%", marginTop: "10px" }}
                      type="primary"
                      disabled
                    >
                      Изпрати имейл
                    </Button>
                  </>
                ) : (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <p
                        style={{
                          fontSize: "13px",
                          marginBottom: "5px",
                          fontWeight: "bold",
                        }}
                      >
                        Ще изпратим билета на имейла, посочен в резервацията,
                        освен ако не въведете друг
                      </p>
                      <Input
                        onChange={(e) => setUserNewEmail(e.target.value)}
                        style={{ height: "35px" }}
                        placeholder="Нов имейл"
                      />
                    </div>
                    <Button
                      onClick={() =>
                        sendEmailTicketsAgain(reservation.ticketNumber)
                      }
                      style={{ width: "100%", marginTop: "10px" }}
                      type="primary"
                    >
                      Изпрати имейл
                    </Button>
                  </>
                )}
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </>
  );
};

export default SendEmailPage;
